export class MonitoringModel {
    start: any ='';
    end: any = '';
    companyId: any = '';
}